import { Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';

import { PageState } from 'app/store/models/page.model';
import { setBannerComponent } from 'app/store/actions/page.action';

@Component({
  selector: 'app-announcements',
  templateUrl: './announcements.component.html',
  styleUrls: ['./announcements.component.scss'],
})
export class AnnouncementsComponent implements OnInit {
  ngOnInit() {}
}
